// src/pages/MainQuotasPage.js
import React from 'react';
import { useState } from 'react';
import SurveyList from '../components/ui/SurveyList';
import { Target } from 'lucide-react';
import TargetIcon from '../components/svgIcons/targetIcon';

function MainQuotasPage() {
	const [activeTab, setActiveTab] = useState('active');
	const [refreshKey, setRefreshKey] = useState(0);

	return (
		<div className="p-6">
			<h2 className="text-2xl font-bold flex items-center mb-4">
				<TargetIcon className="w-8 h-8 mr-2" />
				Manage your quotas
			</h2>
			<p className="pl-10 mb-4">
				Click on the available cards to configure and monitor quotas for your surveys
			</p>

			{/* Main Content Area - Tabbed Interface */}
			<div className="mt-8 bg-white rounded-lg shadow-sm border">
				{/* Tab Navigation */}
				<div className="border-b border-gray-200">
					<nav className="flex space-x-8" aria-label="Tabs">
						<button
							onClick={() => setActiveTab('active')}
							className={`py-4 px-6 text-sm font-medium border-b-2 transition-colors ${
								activeTab === 'active'
									? 'text-gray-800 text-blue-600'
									: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
							}`}
						>
							Active Surveys
						</button>
					</nav>
				</div>

				{/* Tab Content - Use viewport height instead */}
				<div className="h-[70vh] overflow-y-auto overflow-x-hidden pb-20">
					{/* ☝️ Use viewport height for responsive scrolling */}
					
					<div className="p-6">
						{activeTab === 'active' && (
							<div>
								<SurveyList refreshTrigger={refreshKey} surveyStatus={"quotas"} />
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default MainQuotasPage;